import { useAuthenticator } from "@aws-amplify/ui-react";
import { AuthEventData } from "@aws-amplify/ui";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  setCurrentUser,
  setUserCognitoGroups
} from "../features/Users/usersSlice";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { NavigateFunction, useNavigate } from "react-router-dom";

interface handleSignOutProps {
  dispatch: Dispatch<AnyAction>;
  signOut: (data?: AuthEventData | undefined) => void;
  navigate: NavigateFunction;
}
export const handleSignOut = ({
  dispatch,
  signOut,
  navigate
}: handleSignOutProps) => {
  // Clear the user from redux and call sign out
  dispatch(setCurrentUser(undefined));
  dispatch(setUserCognitoGroups([]));
  signOut();
  navigate("/");
};

export const SignOutButton = () => {
  const { t } = useTranslation();
  const { signOut } = useAuthenticator();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <Button
      variant="contained"
      onClick={() => handleSignOut({ dispatch, signOut, navigate })}
    >
      {t("Sign Out")}
    </Button>
  );
};
